import config from '../../../site-config';

const upsolveJSONLD = {
  '@context': 'http://schema.org',
  '@type': 'Organization',
  address: {
    '@context': 'http://schema.org',
    '@type': 'PostalAddress',
    addressLocality: 'New York City',
    addressRegion: 'NY',
    postalCode: '11201',
    streetAddress: '150 Court Street, 2nd Floor',
    addressCountry: 'US',
  },
  url: 'https://upsolve.org',
  name: 'Upsolve',
  sameAs : [
    "https://www.facebook.com/upsolvebankruptcy/",
    "https://twitter.com/upsolvebk",
    "https://www.instagram.com/upsolve/",
    "https://www.youtube.com/channel/UC3LzRsBl6KYHVtp0YGn3sZg",
    "https://www.linkedin.com/company/upsolve/"
  ],
  description: config.siteDescription,
  telephone: '+1-347-850-2656',
  image: 'https://static.upsolve.org/app-preview-bubble.png',
  logo: 'https://upsolve.org/images/upsolve-logo.svg',
  areaServed: {
    '@context': 'http://schema.org',
    '@type': 'AdministrativeArea',
    address: {
      '@context': 'http://schema.org',
      '@type': 'PostalAddress',
      addressCountry: 'US',
    }
  },
  contactPoint: [{
    '@context': 'http://schema.org',
    '@type': 'contactPoint',
    contactType: 'customer service',
    telephone: '+1-347-850-2656',
    email: 'help@upsolve.org',
    areaServed: 'US',
  }],
  // openingHoursSpecification: [
  //   {
  //     '@context': 'http://schema.org',
  //     '@type': 'OpeningHoursSpecification',
  //     dayOfWeek: [
  //       'Monday',
  //       'Tuesday',
  //       'Wednesday',
  //       'Thursday',
  //       'Friday'
  //     ],
  //     opens: '8:00',
  //     closes: '22:00'
  //   },
  //   {
  //     '@context': 'http://schema.org',
  //     '@type': 'OpeningHoursSpecification',
  //     dayOfWeek: [
  //       'Saturday',
  //       'Sunday',
  //     ],
  //     opens: '8:00',
  //     closes: '17:00'
  //   },
  // ],
  // potentialAction: {
  //   '@context': 'http://schema.org',
  //   '@type': 'ViewAction',
  //   target:{
  //     '@type': 'EntryPoint',
  //     urlTemplate: 'https://my.upsolve.org',
  //     inLanguage:'en-US',
  //     actionPlatform:[
  //       'http://schema.org/DesktopWebPlatform',
  //       'http://schema.org/IOSPlatform',
  //       'http://schema.org/AndroidPlatform'
  //     ]
  //   },
  // },
  geo: {
    '@context': 'http://schema.org',
    '@type': 'PostalAddress',
    addressCountry: 'US',
  },
  // makesOffer: {
  //   "@type": "Offer",
  //   "price": "0",
  //   "priceCurrency": "USD"
  // },
};

export default upsolveJSONLD;